var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"interval"},[(_vm.label)?_c('div',{staticClass:"interval-label main-text-color"},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.label))+"\n    ")]):_vm._e(),_c('el-input-number',{attrs:{"value":_vm.inputValue,"min":0,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }